
import React from 'react';


const About = () => {
  return (
    <>
      <div className='MainAbout'>
        <div className='AboutImage'>
            <img src="https://bootstrapmade.com/demo/templates/Ninestars/assets/img/about-img.svg" alt="aboutimage" className='image-fluid' />
        </div>
        <div className='AboutText'>
            <h2>Voluptatem dignissimos provident quasi</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in reprehenderit</p>
            <div className='aboutTextService'>
                <div className='aboutTextSecOne'>
                  <i className="fa fa-codepen"></i>
                  <h3>Corporis voluptates sit</h3>
                  <p>Consequuntur sunt aut quasi enim aliquam quae harum pariatur laboris nisi ut aliquip</p>
                </div>
                <div className='aboutTextSecOne'>
                  <i className="fa fa-codepen"></i>
                  <h3>Corporis voluptates sit</h3>
                  <p>Consequuntur sunt aut quasi enim aliquam quae harum pariatur laboris nisi ut aliquip</p>
                </div>
            </div>
        </div>
      </div>
    </>
  )
}

export default About
